import { View } from "@react-pdf/renderer";
import { PDFTable } from "ui/components/PDF";
import useRelatorioDemonstrativoReceitaDespesaPdfColumns from "./hooks/useRelatorioDemonstrativoReceitaDespesaPdfColumns";
import { TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow } from "./../../../RelatorioDemonstrativo/helper/util";

interface PDFDemonstrativoReceitaEDespesaTableProps {
  items: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow[];
  tableTitle: string;
  ano: string;
}

function OperacaoTable({
  items,
  tableTitle,
  ano,
}: PDFDemonstrativoReceitaEDespesaTableProps) {
  const columns = useRelatorioDemonstrativoReceitaDespesaPdfColumns(
    tableTitle,
    ano
  );

  return (
    <View>
      <PDFTable data={items} columns={columns} tableHeaderVariant="primary" />
    </View>
  );
}

export default OperacaoTable;
